<template>
  <div>
    <check-password v-if="states[mode] === 'CHECKPASSWORD'" @success-password="onChangeMode"/>
    <test-agreement v-if="states[mode] === 'AGREEMENT'" @success-agreement="onChangeMode"/>
    <slot/>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import CheckPassword from '@/components/test/CheckPassword.vue';
import TestAgreement from '@/components/test/TestAgreement.vue';

export default {
  name: 'TestCommonProcess',
  components: { CheckPassword, TestAgreement },
  data: () => ({
    mode: 0,
    states: ['CHECKPASSWORD', 'AGREEMENT']
  }),
  computed: {
    ...mapState('auth', ['profile'])
  },
  methods: {
    onChangeMode () {
      if (this.states[this.mode] === 'AGREEMENT') {
        this.$emit('input', 'TEST')
      } else {
        this.mode++;
      }
    }
  }
}
</script>
